import React, {useState, useEffect} from 'react';
import { View, StyleSheet, Platform, ScrollView,KeyboardAvoidingView, Text} from 'react-native';
import { TextInput, Card, Button, Menu, Provider, DefaultTheme, Searchbar, Portal, Modal} from 'react-native-paper';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faSearch, faTimes, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';
import { user_category } from '../../services/user_api';
import { uploadImage } from '../../services/image';
import emailjs from 'emailjs-com';
import { all_customer_pools, all_manager_pools, all_vendor_pools } from '../../services/pool';
import { url } from '../../utils/url';
import axios from 'axios';
import { roleas } from '../../utils/user';

const theme = {
    ...DefaultTheme,
    roundness: 2,
    colors: {
        ...DefaultTheme.colors,
        primary: '#0cc261',
        accent: '#f1c40f',
    },
};

export default function Register({ navigation},props) {

    let history = useHistory();

    const [visible3, setVisible3] = useState(false);
    const [visible4, setVisible4] = useState(false);
    const [visible5, setVisible5] = useState(false);
    const [searchQuery3, setSearchQuery3] = useState('');
    const [searchQuery4, setSearchQuery4] = useState('');
    const [searchQuery5, setSearchQuery5] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [userCategory, setUserCategory] = useState();
    const [category, setCategory] = useState("Choose Category");
    const [categoryId, setCategoryId] = useState("");
    const [role, setRole] = useState("");
    const [file, setFile] = useState();
    const [img, setImg] = useState();
    const [idType, setIdType] = useState("Choose ID Type");
    const [customers, setCustomers] = useState();
    const [vendors, setVendors] = useState();
    const [managers, setManagers] = useState();
    const [pool_name, setPoolName] = useState("Choose Pool");
    const [pool_id, setPoolId] = useState("");
    const [inputOtp, setInputOtp] = useState();
    const [visible, setVisible] = useState(false);

    const[values,setValues]=useState({
        full_name:'',
        nickname:'',
        email:'',
        contactPersonName: '',
        mobileNo:'',
        password:'',
        confirmPassword:'',
        gstNo:'',
        idNumber:'',
    });
    const [nameError, setNameError]=useState("");
    const [nickError,setNickError]=useState("");
    const [emailError,setEmailError]=useState("");
    const [contactNameError, setContactNameError]=useState("");
    const [mobileError,setMobileError]=useState("");
    const [passwordError,setPasswordError]=useState("");
    const [cpError,setCpError]=useState("");
    const [idError,setIdError]=useState("");
    
    const regmail= /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const regm=/^([+]\d{2})?\d{10}$/;
    const regp1=/[!@#$%^&*()\-_"=+{}; :,<.>]/;
    const regp2=/\w*[A-Z]\w*/;
    
    const ChangeValue1= (newname) => {
        if(!newname)
        {
            setNameError("This feild is required");
        }
        else{
            setNameError("");
        }
        values.full_name=newname
        setValues({...values})
    }
    const ChangeValue2= (newnick) => {
        if(!newnick)
        {
            setNickError("This feild is required");
        }
        else{
            setNickError("");
        }
        values.nickname=newnick
        setValues({...values})
    }
    const ChangeValue3= (newmail) => {
        if(!newmail)
        {
            setEmailError("This feild is required");
        }
        else if(!regmail.test(newmail)){
            setEmailError("Invalid Email Address")
        }
        else{
            setEmailError("");
        }
        values.email=newmail
        setValues({...values})
    }
    const ChangeValue4= (newmobile) => {
        if(!newmobile)
        {
            setMobileError("This feild is required");
        }
        else if(!regm.test(newmobile)){
            setMobileError("Invalid Mobile Number")
        }
        else{
            setMobileError("");
        }
        values.mobileNo=newmobile
        setValues({...values})
    }
    const ChangeValue5= (newpassword) => {
        if(!newpassword)
        {
            setPasswordError("This feild is required");
        }
        else if(!regp1.test(newpassword)){
            setPasswordError("password must have a special character")
        }
        else if(!regp2.test(newpassword)){
            setPasswordError("password must have a capital letter")
        }
        else{
            setPasswordError("");
        }
        values.password=newpassword
        setValues({...values})
    }
    const ChangeValue6= (newcp) => {
        if(!newcp)
        {
            setCpError("This feild is required");
        }
        else if(newcp!==values.password){
            setCpError("password does not match")
        }
        else{
            setCpError("");
        }
        values.confirmPassword=newcp
        setValues({...values})
    }
    const ChangeValue7= (newid) => {
        if(!newid)
        {
            setIdError("This feild is required");
        }
        else{
            setIdError("");
        }
        values.idNumber=newid
        setValues({...values})
    }
    const ChangeValue10= (newcontactname) => {
        if(!newcontactname)
        {
            setContactNameError("This feild is required");
        }
        else{
            setContactNameError("");
        }
        values.contactPersonName=newcontactname
        setValues({...values})
    }
    useEffect(() => {
        //retrieve all user category
        user_category()
        .then(function(result) {
            setUserCategory(result);
        });

        //Retrieve all customer list
        all_customer_pools()
        .then(result => {
            setCustomers(result);
        })

        //Retrieve all vendor list
        all_vendor_pools()
        .then(result => {
            setVendors(result);
        })

        //Retrieve all manager list
        all_manager_pools()
        .then(result => {
            setManagers(result);
        })

        roleas()  
        .then(result => {
            setRole(result);
        })

    }, [userCategory]);

    const showModal = () => {
        setVisible(true);
    };
    const hideModal = () => setVisible(false);

    const openMenu1 = () => setVisible1(true);
    const closeMenu1 = () => setVisible1(false);

    const openMenu2 = () => setVisible2(true);
    const closeMenu2 = () => setVisible2(false);

    const openMenu3 = () => setVisible3(true);
    const closeMenu3 = () => setVisible3(false);

    const openMenu4 = () => setVisible4(true);
    const closeMenu4 = () => setVisible4(false);

    const openMenu5 = () => setVisible5(true);
    const closeMenu5 = () => setVisible5(false);

    function chooseCategory(id, name) {
        setCategoryId(id);
        setCategory(name);
        closeMenu1();
    }

    function submitForm() {
        fetch(url+'/create_user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                category: categoryId,
                role: category,
                idType: idType,
                image: img,
                full_name: values.full_name,
                nick_name: values.nickname,
                email: values.email,
                mobile_no: values.mobileNo,
                contactPersonName: values.contactPersonName,
                idNumber: values.idNumber,
                gst_no:values.gstNo,
                pool_name: pool_name,
                pool_id: pool_id,
                password: values.password,
                confirm_password: values.confirmPassword,
            })
        })
        .then(res => res.json())
        .catch(error => console.log(error))
        .then(data => {
            alert(data.message);
            if(data.data){
                emailjs.send('gmail', 'template_r2kqjja',values, 'user_tzfygekUd6AAYz72qWJrG')
                .then((result) => {
                    console.log(result); 
                }, (error) => {
                    console.log(error.text);
                });
                history.push("/addaddress/"+data.data._id);
            }
        })
        .catch(err=>{
            alert(err.message);
        }); 
    }

    const sendSmsOtp = async (mobileNumber) => {
        const url = 'https://bked.logistiex.com/SMS/msg';
        let returnData;
        const bodyData = {
            "mobileNumber" : mobileNumber,
        };
        const response = await axios.post(url, bodyData);
        if (response.status === 200) {
            returnData = {
                status: 'Success',
                ...response.data,
            };
        } else {
            returnData = {
            status: 'Failure',
            };
        }
    }

    const generateOTP = (mobileNumber) => {
        sendSmsOtp(parseInt(mobileNumber));
        showModal();
    };

    function validateOTP(){
        axios.post("https://bked.logistiex.com/SMS/OTPValidate", {
            mobileNumber:values.mobileNo,
            otp:inputOtp
        })
        .then(response => {
            if(response.data.return){
                submitForm();
                setInputOtp("");
            }
            else{
                alert("Invalid OTP, please try again !!");
            }
        })
        .catch(error => {
            alert("Invalid OTP, please try again !!");
            console.log(error);
        })
    }

    function getFiles(event){
        setFile(event.target.files[0]);
    }

    function ImageSubmitForm(){
        alert("Image Uploaded successfully");
        setImg(uploadImage(file));
        
    }

    function chooseIdType(idType){
        setIdType(idType);
        closeMenu2();
    }

    const handleChange = (mytextname) => {
        return (val) => {
            setValues({ ...values, [mytextname]: val })
        }
    }

    function ChooseCustomer(id, poolName){
        setPoolId(id);
        setPoolName(poolName);
        closeMenu3();
    }

    function ChooseVendor(id, poolName){
        setPoolId(id);
        setPoolName(poolName);
        closeMenu4();
    }

    function ChooseManager(id, poolName){
        setPoolId(id);
        setPoolName(poolName);
        closeMenu5();
    }

    const onChangeSearch = query => setSearchQuery(query);
    const onChangeSearch3 = query => setSearchQuery3(query);
    const onChangeSearch4 = query => setSearchQuery4(query);
    const onChangeSearch5 = query => setSearchQuery5(query);

    const containerStyle = {backgroundColor: 'white',width: '50%', alignSelf: 'center', padding: "10px"};
    function submitError(){
        alert("All feild are required");
    }
    return (
        <Provider theme={theme}>
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                <Portal>
                    <Modal visible={visible} onDismiss={hideModal} contentContainerStyle={containerStyle}>
                        <>
                            <TextInput mode="outlined" label="Enter OTP" value={inputOtp} onChange={(e)=>setInputOtp(e.target.value)} />
                            <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                                <Button mode="contained" onPress={() => generateOTP(values.mobileNo)} style={{width: '40%', marginTop: '20px'}} color="red">Resend OTP</Button>
                                <Button mode="contained" onPress={() => validateOTP()} style={{width: '40%', marginTop: '20px'}}>Validate OTP</Button>
                            </View>
                        </>
                    </Modal>
                </Portal>
                <Card style={styles.card}>
                <KeyboardAvoidingView>
                <ScrollView>
                    <Card.Title titleStyle={styles.title} title="Register User"/>
                    <Card.Content>
                    <Menu
                    visible={visible1}
                    onDismiss={closeMenu1}
                    anchor={<Button style={styles.input} mode="outlined" onPress={openMenu1}>{category}</Button>}>
                        <Searchbar
                            icon={() => <FontAwesomeIcon icon={ faSearch } />}
                            clearIcon={() => <FontAwesomeIcon icon={ faTimes } />}
                            placeholder="Search"
                            onChangeText={onChangeSearch}
                            value={searchQuery}
                        />
                        {Platform.OS=='android' ?
                            <Button icon={() => <FontAwesomeIcon icon={ faPlusCircle } />} mode="outlined" onPress={() => {navigation.navigate('AddUserCategory')}}>Add Category</Button>
                            :
                            <Link to="/addusercategory"><Button mode="outlined" icon={() => <FontAwesomeIcon icon={ faPlusCircle } />}>Add Category</Button></Link>
                        }
                        {userCategory ?
                            userCategory.map((item)=>{
                                if(item.category_name.toUpperCase().search(searchQuery.toUpperCase())!=-1){
                                    if(role=='sales'){
                                        if(item.category_name == 'customer')
                                        return (
                                            <Menu.Item title={item.category_name} onPress={()=>chooseCategory(item._id, item.category_name)} />
                                        )
                                    }
                                    else if(role=='customer'){
                                        if(item.category_name == 'customer')
                                        return (
                                            <Menu.Item title={item.category_name} onPress={()=>chooseCategory(item._id, item.category_name)} />
                                        )
                                    }
                                    else if(role=='buyer'){
                                        if( item.category_name == 'vendor')
                                        return (
                                            <Menu.Item title={item.category_name} onPress={()=>chooseCategory(item._id, item.category_name)} />
                                        )
                                    }
                                    else {
                                        return (
                                            <Menu.Item title={item.category_name} onPress={()=>chooseCategory(item._id, item.category_name)} />
                                        )
                                    }
                                }
                            })
                            :
                            <Menu.Item title="No User Category Available" />
                        }
                    </Menu>
                    <TextInput style={styles.input} mode="outlined" label={category=="customer" ? "Customer Name" : "Full Name"} value={values.full_name} onChangeText={(text)=>ChangeValue1(text)} />
                    <Text style={{color: "red"}}>{nameError}</Text>
                    <TextInput style={styles.input} mode="outlined" label="Nick Name" value={values.nickName} onChangeText={(text)=>ChangeValue2(text)} />
                    <Text style={{color: "red"}}>{nickError}</Text>
                    {(category=="vendor" || category=="customer") &&
                    <>
                        <TextInput style={styles.input} mode="outlined" label="Contact Person Name" value={values.contactPersonName} onChangeText={(text)=>ChangeValue10(text)} />
                        <Text style={{color: "red"}}>{contactNameError}</Text>
                    </>
                    }
                    <TextInput style={styles.input} mode="outlined" label="Email" value={values.email} onChangeText={(text)=>ChangeValue3(text)} />
                    <Text style={{color: "red"}}>{emailError}</Text>
                    <TextInput style={styles.input} mode="outlined" label="Mobile No" value={values.mobileNo} onChangeText={(text)=>ChangeValue4(text)} />
                    <Text style={{color: "red"}}>{mobileError}</Text>
                    <Menu
                    visible={visible2}
                    onDismiss={closeMenu2}
                    anchor={<Button style={styles.input} mode="outlined" onPress={openMenu2}>{idType}</Button>}>
                        <Menu.Item title="Aadhar Card" onPress={()=>chooseIdType("Aadhar Card")} />
                        <Menu.Item title="Pan Card" onPress={()=>chooseIdType("Pan Card")} />
                        <Menu.Item title="Voter Id" onPress={()=>chooseIdType("Voter Id")} />
                        <Menu.Item title="Driving License" onPress={()=>chooseIdType("Driving License")} />
                        <Menu.Item title="Passport" onPress={()=>chooseIdType("Passport")} />
                    </Menu>
                    <TextInput style={styles.input} mode="outlined" label="Govt ID Number" value={values.idNumber} onChangeText={(text)=>ChangeValue7(text)}/>
                    <Text style={{color: "red"}}>{idError}</Text>
                    {Platform.OS=='android' ? 
                        null 
                    :
                        <View style={{flexDirection: 'row', marginTop: '2%'}}>
                            <input type="file" name="file" placeholder="Image"
                            style={{flex: 3, border: '1px solid gray', padding: '1%', borderRadius: '1px'}}
                            onChange={getFiles}
                            />
                            <Button mode="contained" style={styles.button} onPress={()=>ImageSubmitForm()}>Upload Image</Button>
                        </View>
                    }
                    {(category=="vendor" || category=="customer") &&
                        <TextInput style={styles.input} mode="outlined" label="GST No" value={values.gstNo} onChangeText={handleChange('gstNo')} />
                    }
                    {(category=="sales" || category=="customer") &&
                    <Menu
                    visible={visible3}
                    onDismiss={closeMenu3}
                    anchor={<Button style={styles.input} mode="outlined" onPress={openMenu3}>{pool_name}</Button>}>
                        <Searchbar
                            icon={() => <FontAwesomeIcon icon={ faSearch } />}
                            clearIcon={() => <FontAwesomeIcon icon={ faTimes } />}
                            placeholder="Search"
                            onChangeText={onChangeSearch3}
                            value={searchQuery3}
                        />
                        {Platform.OS=='android' ?
                            <Button icon={() => <FontAwesomeIcon icon={ faPlusCircle } />} mode="outlined" onPress={() => {navigation.navigate('AddItemGrade')}}>Add Grade</Button>
                            :
                            <Link to="/addcustomerpool"><Button mode="outlined" icon={() => <FontAwesomeIcon icon={ faPlusCircle } />}>Add Customer Pool</Button></Link>
                        }
                        {customers ?
                            customers.map((item)=>{
                                return (
                                    <Menu.Item title={item.pool_name} onPress={()=>ChooseCustomer(item._id, item.pool_name)} />
                                )
                            })
                            :
                            <Menu.Item title="No Customer Pool Available" />
                        }
                    </Menu>
                    }
                    {category=="buyer" &&
                    <Menu
                    visible={visible4}
                    onDismiss={closeMenu4}
                    anchor={<Button style={styles.input} mode="outlined" onPress={openMenu4}>{pool_name}</Button>}>
                        <Searchbar
                            icon={() => <FontAwesomeIcon icon={ faSearch } />}
                            clearIcon={() => <FontAwesomeIcon icon={ faTimes } />}
                            placeholder="Search"
                            onChangeText={onChangeSearch4}
                            value={searchQuery4}
                        />
                        {Platform.OS=='android' ?
                            <Button icon={() => <FontAwesomeIcon icon={ faPlusCircle } />} mode="outlined" onPress={() => {navigation.navigate('AddItemGrade')}}>Add Grade</Button>
                            :
                            <Link to="/addvendorpool"><Button mode="outlined" icon={() => <FontAwesomeIcon icon={ faPlusCircle } />}>Add Vendor Pool</Button></Link>
                        }
                        {vendors ?
                            vendors.map((item)=>{
                                return (
                                    <Menu.Item title={item.pool_name} onPress={()=>ChooseVendor(item._id, item.pool_name)} />
                                )
                            })
                            :
                            <Menu.Item title="No Vendor Pool Available" />
                        }
                    </Menu>
                    }
                    {category=="manager" &&
                    <Menu
                    visible={visible5}
                    onDismiss={closeMenu5}
                    anchor={<Button style={styles.input} mode="outlined" onPress={openMenu5}>{pool_name}</Button>}>
                        <Searchbar
                            icon={() => <FontAwesomeIcon icon={ faSearch } />}
                            clearIcon={() => <FontAwesomeIcon icon={ faTimes } />}
                            placeholder="Search"
                            onChangeText={onChangeSearch5}
                            value={searchQuery5}
                        />
                        {Platform.OS=='android' ?
                            <Button icon={() => <FontAwesomeIcon icon={ faPlusCircle } />} mode="outlined" onPress={() => {navigation.navigate('AddItemGrade')}}>Add Grade</Button>
                            :
                            <Link to="/addmanagerpool"><Button mode="outlined" icon={() => <FontAwesomeIcon icon={ faPlusCircle } />}>Add Manager Pool</Button></Link>
                        }
                        {managers ?
                            managers.map((item)=>{
                                return (
                                    <Menu.Item title={item.pool_name} onPress={()=>ChooseManager(item._id, item.pool_name)} />
                                )
                            })
                            :
                            <Menu.Item title="No Manager Pool Available" />
                        }
                    </Menu>
                    }
                    <TextInput style={styles.input} mode="outlined" label="Password" value={values.password} onChangeText={(text)=>ChangeValue5(text)} secureTextEntry={true}/>
                    <Text style={{color: "red"}}>{passwordError}</Text>
                    <TextInput style={styles.input} mode="outlined" label="Confirm Password" value={values.confirmPassword} onChangeText={(text)=>ChangeValue6(text)} secureTextEntry={true}/>
                    <Text style={{color: "red"}}>{cpError}</Text>
                    {nameError=="" && nickError=="" && mobileError=="" && emailError=="" && idError==""
                    && passwordError=="" && cpError==""
                        ? <Button mode="contained" style={styles.button} onPress={() => generateOTP(values.mobileNo)}>Save & Add Address</Button>
                        :
                        <Button mode="contained" style={styles.button} onPress={() => submitError()}>Save & Add Address</Button>

                    }
                    </Card.Content>
                </ScrollView>
                </KeyboardAvoidingView>
                </Card>
            </View>
        </Provider>
    );
}

const styles = StyleSheet.create({
    card: {
        alignSelf: 'center',
        padding: '1%',
        ...Platform.select({
            ios: {
                
            },
            android: {
                marginTop: '2%',
                marginBottom: '10%',
                width: '90%',
            },
            default: {
                boxShadow: '0 4px 8px 0 gray, 0 6px 20px 0 gray',
                marginTop: '4%',
                marginBottom: '4%',
                width: '75%',
            }
        })
    },
    input: {
        marginTop: '2%',
        width: '100%',
        ...Platform.select({
            ios: {
                
            },
            android: {
                
            },
            default: {
                
            }
        })
    },
    title: {
        ...Platform.select({
            ios: {
                
            },
            android: {
                marginTop: '1%',
                textAlign: 'center',
                color: 'green',
                fontFamily: 'Roboto'
            },
            default: {
                textAlign: 'center',
                color: 'green',
                fontSize: 28,
                fontFamily: 'Roboto'
            }
        })
    },
    button: {
        marginTop: '2%',
    }
}); 